<ng-container *appModule="'AREA_ACTIONS_MAP_LAYERS'">
  @if (currentAreaAction) {
    <div class="container mt-5">
      <div class="row">
        <div class="col-12">
          <div class="text-center">
            <h5 class="fw-bold">{{ "COMPONENTS.AREA_ACTIONS.HEADING" | translate }}</h5>
          </div>
          <div class="d-flex w-100 justify-content-around align-items-center mb-3">
            <button
              mat-raised-button
              color="accent"
              (click)="onLeftArrowClick()"
              [disabled]="areaActions().indexOf(currentAreaAction) === 0"
              [attr.aria-label]="'TABLES.GENERAL.PAGINATION.PREVIOUS_PAGE' | translate"
            >
              {{ "TABLES.GENERAL.PAGINATION.PREVIOUS_PAGE" | translate }}
            </button>
            <div class="d-flex flex-column text-center">
              <strong>{{ currentAreaAction.area }} - {{ currentAreaAction.municipality }}</strong>
              <span>{{ currentAreaAction ? currentAreaAction!.zipCodeFrom : "" }} - {{ currentAreaAction ? currentAreaAction!.zipCodeTo : "" }}</span>
              <span class="fst-italic text-muted">{{ currentAreaAction!.dateFrom | date: "dd-MM-yyyy" }} - {{ currentAreaAction!.dateTo | date: "dd-MM-yyyy" }}</span>
            </div>
            <button
              mat-raised-button
              color="accent"
              (click)="onRightArrowClick()"
              [disabled]="areaActions().indexOf(currentAreaAction) === areaActions().length - 1"
              [attr.aria-label]="'TABLES.GENERAL.PAGINATION.NEXT_PAGE' | translate"
            >
              {{ "TABLES.GENERAL.PAGINATION.NEXT_PAGE" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  }
</ng-container>

<div class="row">
  <div class="col-md">
    <google-map
      class="google-map"
      [center]="mapSettings.center"
      [zoom]="mapSettings.zoom"
      [ariaSetSize]=""
      width="100%"
      [options]="mapSettings.options"
      (zoomChanged)="zoomChangedEventHandler()"
      (centerChanged)="centerChangedEventHandler()"
    >
      @if (planningOverlay) {
        @for (set of sets; track set) {
          @for (consult of set.consults; track consult; let i = $index) {
            @if (consult.marker) {
              <map-marker
                [position]="consult.marker.position"
                [icon]="'assets/images/mapIcons/emptyRouteBlue.svg'"
                [label]="{ text: (i + 1).toString(), color: 'white', fontSize: '18px', fontWeight: 'bold' }"
                [visible]="set.visible"
                [options]="{ zIndex: 100 }"
                (mapClick)="openInfo({ id: consult.id.toString(), state: consult.state, position: consult.marker.position, options: { zIndex: 100 } })"
              ></map-marker>
            }
            <!-- z index should be done differently -->
          }
          <map-polyline [path]="set.lines.path" [options]="{ visible: set.visible, icons: set.lines.icons, strokeColor: set.color }"></map-polyline>
        }
      }
      <ng-container>
        @for (marker of markerPositions; track marker; let i = $index) {
          <map-marker
            [position]="marker.position"
            [icon]="'assets/images/mapIcons/' + marker.state.name.toLowerCase() + '.svg'"
            (mapClick)="openInfo(marker)"
            [options]="marker.options"
          >
          </map-marker>
        }
      </ng-container>
      <ng-container *appModule="'AREA_ACTIONS'">
        @for (marker of areaActionMarkers; track marker; let i = $index) {
          <map-marker [icon]="'assets/images/mapIcons/areaAction.svg'" [position]="marker.position" [options]="marker.options"> </map-marker>
        }
      </ng-container>
      <ng-container *appModule="'AREA_ACTIONS_MAP_LAYERS'">
        @for (i of mapLayers; track i) {
          <map-polygon [paths]="i"></map-polygon>
        }
      </ng-container>
    </google-map>
  </div>
  @if (selectedRequest) {
    <div #consult class="col-lg-4 position-relative overflow-hidden">
      <div>
        <div class="closeButton position-absolute end-0 pe-3">
          <button mat-icon-button (click)="closeInfo()">
            <mat-icon class="mb-2">close</mat-icon>
          </button>
        </div>
        <app-energy-consult [coaches]="coaches()" [requestStates]="requestStates()" [energyConsult]="selectedRequest!" [mapView]="true" [actions]="0"></app-energy-consult>
        <!-- /* [actions]="applicationService.session.user!.status === 'PendingDeleted' ? 2 : 0" */ -->
      </div>
    </div>
  }
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <ng-container *ngTemplateOutlet="planningButtonTemplate"></ng-container>
      <ng-container *ngTemplateOutlet="legendButtonTemplate"></ng-container>
    </div>
    @if (legendOverlay) {
      <ng-container *ngTemplateOutlet="LegendOverlayTemplate"> </ng-container>
    }
  </div>

  @if (planningOverlay) {
    <div class="filterCardContainer">
      @for (set of sets; track set; let i = $index) {
        <mat-card class="filterCard">
          <div class="card-row">
            <div style="display: flex; flex-direction: column; justify-content: space-around">
              @for (coach of set.coaches; track coach) {
                <div>
                  <b>
                    {{ coach.fullName }}
                  </b>
                </div>
              }
              <div>{{ set.date | date: "dd-MM-yyyy" }}</div>
            </div>
            <div style="display: flex; flex-direction: column; justify-content: center">
              <button mat-icon-button [disabled]="false" (click)="removeSet(i)">
                <mat-icon>clear</mat-icon>
              </button>
              <button mat-icon-button (click)="set.visible = !set.visible">
                @if (set.visible) {
                  <mat-icon>visibility</mat-icon>
                }
                @if (!set.visible) {
                  <mat-icon>visibility_off</mat-icon>
                }
              </button>
            </div>
          </div>
          @for (consult of set.consults; track consult; let i = $index) {
            <div class="card-row">
              <p>
                <span>{{ i + 1 + ". " }}</span
                >{{ consult.location }}
              </p>
              <p>{{ consult.appointmentDate | date: "HH:mm" }}</p>
              @if (consult.marker === undefined) {
                <mat-icon [color]="'warn'" style="cursor: pointer" [matTooltip]="'COMPONENTS.DASHBOARD.PLANNING_LOCATION_NOT_FOUND' | translate">warning</mat-icon>
              }
            </div>
          }
        </mat-card>
      }
      <mat-card class="filterCard">
        <div class="card-row">
          <div style="display: flex; flex-direction: column">
            <mat-form-field>
              <mat-label>{{ "COMPONENTS.DASHBOARD.PLANNING_FORM_LABELS.COACH" | translate }}</mat-label>
              <mat-select [formControl]="form.controls.coaches" multiple>
                @for (coach of coaches(); track coach) {
                  <mat-option [value]="coach">
                    {{ coach.fullName }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ "COMPONENTS.DASHBOARD.PLANNING_FORM_LABELS.DATE" | translate }}</mat-label>
              <input matInput [matDatepicker]="picker" [formControl]="form.controls.date" />
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div style="display: flex; flex-direction: row; justify-content: space-around">
          <button mat-icon-button [disabled]="false" (click)="clearForm()">
            <mat-icon>clear</mat-icon>
          </button>
          <button mat-icon-button [disabled]="form.invalid || loading" (click)="addSet()">
            <mat-icon>add_circle_outline</mat-icon>
          </button>
        </div>
      </mat-card>
    </div>
  }
</div>

<ng-template #LegendOverlayTemplate>
  <div class="col-lg4 position-relative overflow-hidden">
    <div class="row">
      <div class="col-12">
        <div class="legenda">
          @for (item of legendItems; track item) {
            <div *appIsRole="item.coordinatorOnly ? ['coordinator'] : ['coach', 'coordinator']" class="legenda_item">
              <img [alt]="'COMPONENTS.TILE.STATUSES.' + item.stateName | translate" [src]="'assets/images/mapIcons/' + item.iconFile + '.svg'" />
              <span>{{ "COMPONENTS.TILE.STATUSES." + item.stateName | translate }}</span>
            </div>
          }
          <div *appModule="'AREA_ACTIONS'">
            <img [alt]="'MENU.ITEMS.AREA_ACTIONS' | translate" [src]="'assets/images/mapIcons/areaAction.svg'" />
            <span>{{ "MENU.ITEMS.AREA_ACTIONS" | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #legendButtonTemplate>
  <span
    matTooltip="{{ 'COMPONENTS.EVERYWHERE.MAPVIEWHINTS.LEGEND_HINT' | translate }}"
    (click)="toggleLegendOverlay()"
    [style.color]="legendOverlay ? 'var(--primary-button)' : 'gray'"
    [style.cursor]="'pointer'"
    [style.width]="'auto'"
    >{{ "COMPONENTS.EVERYWHERE.MAPVIEWHINTS.LEGEND" | translate }}</span
  >
</ng-template>
<ng-template #planningButtonTemplate>
  <button
    mat-icon-button
    (click)="togglePlanningOverlay()"
    matTooltip="{{ 'COMPONENTS.EVERYWHERE.MAPVIEWHINTS.PLANNING_HINT' | translate }}"
    [style.color]="planningOverlay ? 'var(--primary-button)' : 'gray'"
  >
    <mat-icon>directions</mat-icon>
  </button>
</ng-template>

<ng-template #unsavedDialog>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md touchScreenAccessability">
        <h3 class="title">{{ "COMPONENTS.COACH_REQUEST.DIALOGS.SAVE_UNSAVED_CHANGES.TITLE" | translate }}</h3>
        <p>{{ "COMPONENTS.COACH_REQUEST.DIALOGS.SAVE_UNSAVED_CHANGES.DESCRIPTION" | translate }}</p>

        <button mat-raised-button color="primary" (click)="dialog.close()">{{ "COMPONENTS.DIALOG.BACK" | translate }}</button>
        <button mat-raised-button color="warn" (click)="discardDateChanges()">
          {{ "COMPONENTS.DIALOG.CONTINUE_DISCARD" | translate }}
        </button>
        <button mat-raised-button color="primary" [disabled]="!!this.consultComponent?.formGroup?.invalid" (click)="saveDateChanges()">
          {{ "COMPONENTS.DIALOG.CONTINUE_SAVE" | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
